<template>
  <section class="question-content">
    <div class="left">
      <div class="first">
        <div class="title">{{title}}</div>
        <div>
          <span>{{score_}}: <i>{{score}}</i></span>
        </div>
      </div>
      <div class="second">
        <p class="content" v-html="trustedContent"></p>
        <div class="token" v-if="!gameOver && !solved">
          <input type="text" v-model="flag" placeholder="Flag"/>
          <a class="btn btn-large btn-block" @click="submit">Hack</a>
        </div>
        <p class="result" v-if="!gameOver && solved"><img src="../img/solvedSuccessfully.png" height="150px"></p>
        <p class="result" v-if="gameOver">{{ctfOver_}}</p>
      </div>
      <div class="third">
        <span v-if="ctfMode === 'teams'">{{teamSolvedCount_}}</span>
        <span v-if="ctfMode === 'users'">{{userSolvedCount_}}</span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{name_}}</span>
              <span>{{score_}}</span>
              <span>{{time_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in result">
            <router-link :to="r.tid && '/team/' + r.tid || ''">
              <span>{{r.name}}</span>
              <span>{{r.score}}</span>
              <span>{{formatTime(r.timestamp)}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import marked from 'marked'

  import { challenge, submit } from '@/utils/api.js'
  import { formatTime } from '@/utils'
  import i18n from '@/i18n'
  import bus from '@/utils/event_bus.js'

  export default {
    data () {
      return {
        title: '',
        score: 0,
        content: '',
        totalSolved: '0',
        solved: 0,
        flag: '',
        result: []
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'ctfMode']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'score_', 'teamSolved_', 'ctfOver_',
        'teamSolvedCount_', 'userSolvedCount_', 'name_', 'score_', 'time_',
        'errParam_', 'errNoLogin_', 'errGameOver_', 'errWrongFLag_',
        'solvedSuccessfully_'
      ]),
      trustedContent () {
        return marked(this.content)
      }
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      init () {
        if (!this.gameOver && !this.profile.name) return this.$router.push('/login')

        challenge(this.$route.params.pid)
          .then((data) => {
            this.solved = data.solve_nth
            this.score = data.score
            this.content = data.desc
            this.title = data.title
            this.totalSolved = data.total_solved

            const arr = data.top_solved || []

            this.result = arr
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      submit () {
        submit(this.$route.params.pid, this.flag)
          .then((data) => {
            this.solved = true
            this.$emit('msg', {
              msg: this.solvedSuccessfully_,
              type: 'info',
              delay: 2000,
              callback: () => {
                this.init()
              }
            })
          })
          .catch((err) => {
            const [error] = err.message.split(': ')
            let msg = error
            switch (error) {
              case 'invalid_param': {
                msg = this.errParam_
                break
              }
              case 'login_required': {
                msg = this.errNoLogin_
                break
              }
              case 'game_over': {
                msg = this.errGameOver_
                break
              }
              case 'wrong_flag': {
                msg = this.errWrongFLag_
                break
              }
              default:
            }

            if (msg) {
              this.$emit('msg', {
                msg,
                type: 'error',
                delay: 2000
              })
            }
          })
      },
      UPDATE (data) {
        if (data.pid === this.$route.params.pid) this.init()
      }
    },
    created () {
      this.init()
      bus.$on('UPDATE', this.UPDATE)
    },
    beforeDestroy () {
      bus.$off('UPDATE', this.UPDATE)
    }
  }
</script>

<style scoped lang="less">
  .question-content .left {
    .first {
      height: auto;
      .title {
        white-space: normal;
        word-break: break-word;
      }

      span {
        margin-left: 0;
      }
    }
    .second {
      p.result {
        font-size: 18px;
        padding: 10px;
        border-radius: 6px;
        margin-top: 20px;
        text-align: center;
        background: #000000;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/challenge_info.vue